'use client'

import dynamic from 'next/dynamic'

// Opened from a click, so it stays off the critical path.
export const RegionalSettingsModalLazy = dynamic(
  () => import('./RegionalSettingsModal').then(({RegionalSettingsModal}) => RegionalSettingsModal),
  {ssr: false},
)
